import { Component, Input, Output, EventEmitter, OnInit, inject, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FolhaServicoService } from 'src/app/services/folha-servico-service/folha-servico.service';
import { AcertoHoraService } from 'src/app/services/acerto-hora-service/acerto-hora.service';
import { FolhaServico } from 'src/app/models/folha-servico';

@Component({
  selector: 'app-proximas-escalas-modal',
  templateUrl: './proxima-escala-modal.component.html',
  styleUrls: ['./proxima-escala-modal.component.scss'],
  imports: [CommonModule, FormsModule, IonicModule],
  standalone: true
})
export class ProximasEscalasModalComponent implements OnInit, OnChanges {
  @Input() isOpen: boolean = false;
  @Input() motorista: any = null;
  @Output() closeModal = new EventEmitter<void>();

  private folhaServicoService = inject(FolhaServicoService);
  private acertoHoraService = inject(AcertoHoraService);

  dataSelecionada: string = '';
  dataAtual: string = this.obterDataAtualBrasil();
  dataMaxima: string = this.obterDataMaximaBrasil();
  
  isLoading: boolean = false;
  folhaSelecionada: FolhaServico | null = null;
  listaDeTarefas: any[] = [];
  
  // 🔥 CAMPOS ADICIONAIS
  grupoAlocacaoCodigo: string = '';
  codigoGrupoLinha: string = '';
  tarefaDupla: string = '';

  ngOnInit() {
    this.dataSelecionada = this.obterDataAtualBrasil();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      this.dataSelecionada = this.obterDataAtualBrasil();
      this.carregarEscala();
    }
  }

  private obterDataAtualBrasil(): string {
    const hoje = new Date();
    const formatador = new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    const partes = formatador.formatToParts(hoje);
    const ano = partes.find(p => p.type === 'year')?.value;
    const mes = partes.find(p => p.type === 'month')?.value;
    const dia = partes.find(p => p.type === 'day')?.value;
    return `${ano}-${mes}-${dia}`;
  }

  private obterDataMaximaBrasil(): string {
    const hoje = new Date();
    hoje.setDate(hoje.getDate() + 2);
    const formatador = new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    const partes = formatador.formatToParts(hoje);
    const ano = partes.find(p => p.type === 'year')?.value;
    const mes = partes.find(p => p.type === 'month')?.value;
    const dia = partes.find(p => p.type === 'day')?.value;
    return `${ano}-${mes}-${dia}`;
  }

  onDataSelecionadaChange() {
    this.carregarEscala();
  }

  async carregarEscala() {
    if (!this.motorista?.matricula) {
      return;
    }

    this.isLoading = true;
    this.folhaSelecionada = null;
    this.listaDeTarefas = [];
    this.grupoAlocacaoCodigo = '';
    this.codigoGrupoLinha = '';
    this.tarefaDupla = '';

    try {
      const dataApenas = this.dataSelecionada.split('T')[0];
      
      const folhaAtiva = await this.folhaServicoService.buscarFolhaAtivaPorMatricula(this.motorista.matricula).toPromise();
      const folhaServicoId = folhaAtiva?.id;

      const folha = await this.folhaServicoService
        .buscarFolhaServico(this.motorista.matricula, dataApenas, folhaServicoId)
        .toPromise();

      if (!folha) {
        this.isLoading = false;
        return;
      }

      this.folhaSelecionada = folha;
      this.listaDeTarefas = folha.tarefas || [];

      // 🔥 EXTRAI GRUPO DE ALOCAÇÃO DO NÍVEL DA FOLHA
      this.grupoAlocacaoCodigo = folha.grupoAlocacaoCodigo ? String(folha.grupoAlocacaoCodigo) : '';

      // 🔥 EXTRAI GRUPO DE LINHA E TAREFA DUPLA DA PRIMEIRA TAREFA
      if (this.listaDeTarefas.length > 0) {
        const primeiraTarefa = this.listaDeTarefas[0];
        this.codigoGrupoLinha = primeiraTarefa.codigo_grupo_linha ? String(primeiraTarefa.codigo_grupo_linha) : '';
        // 🔥 CORRIGIDO: Mostra o número da tarefa_dupla (1, 2, 3, etc.)
        this.tarefaDupla = primeiraTarefa.tarefa_dupla !== undefined && primeiraTarefa.tarefa_dupla !== null 
          ? String(primeiraTarefa.tarefa_dupla) 
          : '';
      }

      console.log('📊 Dados extraídos:', {
        grupoAlocacaoCodigo: this.grupoAlocacaoCodigo,
        codigoGrupoLinha: this.codigoGrupoLinha,
        tarefaDupla: this.tarefaDupla
      });

    } catch (error) {
      console.error('Erro ao carregar escala:', error);
    } finally {
      this.isLoading = false;
    }
  }

  formatarHora(hora: string | null | undefined): string {
    if (!hora) return '';
    const partes = hora.split(':');
    return `${partes[0]}:${partes[1]}`;
  }

  formatarLinhaPrefixo(linhaPrefixo: string): string {
    if (!linhaPrefixo || linhaPrefixo.length === 0) return '';
    const ultimoDigito = linhaPrefixo.slice(-1);
    const resto = linhaPrefixo.slice(0, -1);
    return `${resto}-${ultimoDigito}`;
  }

  fechar() {
    this.closeModal.emit();
  }
}